import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

import img1 from "../../img/driver-1.webp";
import img2 from "../../img/driver-2.webp";
import img3 from "../../img/driver-4.webp";
import img4 from "../../img/driver-3.webp";
import team1 from "../../img/team-1.webp";
import team2 from "../../img/team-2.webp";
import team3 from "../../img/team-3.webp";
import team4 from "../../img/team-4.webp";

import "./style.css";

const Team = () => {
  const { t } = useTranslation();

  const onClick = (e) => {
    e.preventDefault();
  };

  return (
    <section className="gauto-driver-area section_70">
      <Container>
        <Row>
          <Col md={12}>
            <div className="site-heading">
              <h4>Professional </h4>
              <h2>Team</h2>
            </div>
          </Col>
        </Row>x 
        <Row>
          <Col lg={3} sm={6}>
            <div className="single-driver">
              <div className="driver-image">
                <img src={team1} alt="driver 1" />
                <div className="hover">
                  <ul className="social-icon">
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaLinkedinIn />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaInstagram />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="driver-text">
                <div className="driver-name">
                  <Link to="/">
                    <h3>Tahir Rajani</h3>
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} sm={6}>
            <div className="single-driver">
              <div className="driver-image">
                <img src={team2} alt="driver 1" />
                <div className="hover">
                  <ul className="social-icon">
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaLinkedinIn />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaInstagram />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="driver-text">
                <div className="driver-name">
                  <Link to="/">
                    <h3>Ali Bhimani</h3>
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} sm={6}>
            <div className="single-driver">
              <div className="driver-image">
                <img src={team3} alt="driver 1" />
                <div className="hover">
                  <ul className="social-icon">
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaLinkedinIn />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaInstagram />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="driver-text">
                <div className="driver-name">
                  <Link to="/">
                    <h3>Clarence Mhoka</h3>
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} sm={6}>
            <div className="single-driver">
              <div className="driver-image">
                <img src={team4} alt="driver 1" />
                <div className="hover">
                  <ul className="social-icon">
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaLinkedinIn />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={onClick}>
                        <FaInstagram />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="driver-text">
                <div className="driver-name">
                  <Link to="/">
                    <h3>Stephen Mbwiga</h3>
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="load-more">
              <Link to="/" onClick={onClick} className="gauto-btn">
                {t("more_member")}
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Team;
